export default "__VITE_ASSET__D1UTCn2v__"